import { AxiosResponse } from 'axios';
import { Result } from '@/main/models/common/resultResponse';
import { CategoryResponse } from '@/main/models/response';

export abstract class ICategoryApi {
  abstract getDomain(
    isCanastaBasica: boolean
  ): Promise<AxiosResponse<Result<CategoryResponse[]>>>;
}
